import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThermostat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"thermostat, temprature"} maskId="square-filled-radius-0-stroke-1-IconThermostat"><path fillRule="evenodd" clipRule="evenodd" d="M7 2H11V12.4162C12.7653 13.1875 14 14.949 14 17C14 19.7614 11.7614 22 9 22C6.23858 22 4 19.7614 4 17C4 14.949 5.23466 13.1875 7 12.4162V2ZM15 3H20V4H15V3ZM15 7H20V8H15V7ZM15 11H20V12H15V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconThermostat;
